<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProductoPaginaIdroop"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionProductPagesOfGratefulnessModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionProductPagesOfGratefulnessModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.nombre }}</b>
          {{ $t('mEditionProductPagesOfGratefulnessModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
          {{ $t('mEditionProductPagesOfGratefulnessModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionProductPagesOfGratefulnessModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductPagesOfGratefulnessModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPagesOfGratefulnessModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    deleteProductoPaginaIdroop () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('producto', 'deleteProductoPaginaIdroop', {}, [this.$modal.element.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalDelete', 'deleteProductoPaginaIdroop', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionProductPagesOfGratefulnessModalDelete', 'deleteProductoPaginaIdroop', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
